<template>
  <div>
    <span>{{ ssoInfo.errMsg }}</span>
    <init-data ref="initData"></init-data>
  </div>
</template>

<script>
import initData from '@/components/frame/initData/initData'
import { ssoTokenLogin } from '@/api/frame/sso/ssoApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'SsoPage',
  components: {
    initData
  },
  data() {
    return {
      ssoInfo: {
        errMsg: '',
        shopId: ''
      }
    }
  },
  created() {
    this.initMethod()
  },
  methods: {
    initMethod() {
      const _hcAccessToken = this.$route.query.token
      if (!_hcAccessToken) {
        this.ssoInfo.errMsg = this.$t('sso.noTokenError')
        return
      }

      const _targetUrl = this.$route.query.targetUrl
      this.ssoInfo.shopId = this.$route.query.shopId || getShopId()
      
      if (!_targetUrl) {
        this.ssoInfo.errMsg = this.$t('sso.noTargetUrlError')
        return
      }
      
      this.authLogin(_hcAccessToken, _targetUrl)
    },
    async authLogin(_hcAccessToken, _targetUrl) {
      try {
        const data = {
          hcAccessToken: _hcAccessToken
        }
        
        const res = await ssoTokenLogin(data)
        if (res.code != 0) {
          this.ssoInfo.errMsg = res.msg
          return
        }

        localStorage.setItem('token', res.token)

        this.$refs.initData.loadShopInfo({
          url: decodeURIComponent(_targetUrl),
          shopId: this.ssoInfo.shopId
        })
      } catch (error) {
        console.error('SSO登录失败:', error)
      }
    }
  }
}
</script>

<style scoped>
/* 可以添加样式 */
</style>